import { useLang } from "@/lib/i18n";
import { nok } from "@/lib/format";

/**
 * Printed-menu feel as real HTML: navy panel, cream paper card, thin gold rules, dotted leaders.
 * `menu` comes from /content (dining.menus[]): { id, title, subtitle, note, items:[{name, price, desc}] }
 */
export const MenuCard = ({ menu, testid, className = "", cta }) => {
  const { lang, tr } = useLang();
  if (!menu) return null;
  return (
    <section className={`grain rounded-[28px] bg-primary p-3 text-primary-foreground sm:p-4 ${className}`} data-testid={testid}>
      <div className="rounded-[20px] bg-cream px-6 py-7 text-foreground sm:px-9 sm:py-9">
        <header className="text-center">
          <p className="text-[0.6875rem] font-semibold uppercase tracking-[0.28em] text-muted-foreground">Skånevik Fjordhotel</p>
          <h3 className="mt-3 text-[1.75rem] font-bold uppercase leading-none tracking-[0.04em] text-foreground sm:text-[2.125rem]">{tr(menu.title)}</h3>
          {menu.subtitle && <p className="mt-2 text-sm text-muted-foreground">{tr(menu.subtitle)}</p>}
          <div className="mx-auto mt-5 flex items-center gap-3" aria-hidden>
            <span className="h-px flex-1 bg-gold/70" />
            <span className="h-1.5 w-1.5 rotate-45 bg-gold" />
            <span className="h-px flex-1 bg-gold/70" />
          </div>
        </header>
        <ul className="mt-6 space-y-5" data-testid={testid ? `${testid}-items` : undefined}>
          {(menu.items || []).map((it, i) => (
            <li key={i} data-testid={testid ? `${testid}-item-${i}` : undefined}>
              <div className="flex items-baseline gap-3">
                <span className="text-[1.0625rem] font-semibold uppercase tracking-[0.06em] text-foreground">{tr(it.name)}</span>
                <span className="leader" aria-hidden />
                <span className="tnum shrink-0 text-[1.0625rem] font-semibold text-foreground">{nok(it.price, lang)}</span>
              </div>
              {it.desc && <p className="mt-1 max-w-[60ch] text-sm leading-relaxed text-muted-foreground">{tr(it.desc)}</p>}
            </li>
          ))}
        </ul>
        <footer className="mt-7 border-t border-gold/50 pt-4 text-xs text-muted-foreground">
          {menu.note && <p>{tr(menu.note)}</p>}
          {cta && <div className="mt-4">{cta}</div>}
        </footer>
      </div>
    </section>
  );
};
